import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import SalarisSvg from 'page/catalog/BasicWelcomePage/salaris/salaris.svg'
import { SALARIS } from 'page/catalog/BasicWelcomePage/salaris/util'
import { demo } from 'page/catalog/store/CatalogStore'
import css from './SalarisButton.module.scss'

export const SalarisButton = observer(() => {
  const onClick = useLatestCallback(() => {
    demo.it.startBasic(SALARIS)
  })

  return <Space className={css.button} gap={16} center onClick={onClick}>
    <SalarisSvg />
    <Typo size={32} upper one semi center>
      САЛАРИС
    </Typo>
  </Space>
})
